/* ============================================================
   Mōushi — gift-cup.js
   « 1 Cup MŌUSHI offerte avec votre commande » :
   - auto-ajoute la Cup au panier dès qu'un doypack y entre ;
   - n'insiste pas si le client retire la Cup (sessionStorage) ;
   - affiche la note cadeau dans le drawer panier.
   La gratuité elle-même est appliquée par la remise automatique
   Shopify « Achetez X, obtenez Y » à l'étape de paiement.
   Réversible : retirer ce fichier + sa balise dans theme.liquid.
   ============================================================ */
(function () {
  'use strict';

  var DOYPACKS   = [10242471919945, 10363648475465]; /* Not Coffee 20 doses · 30 doses (édition limitée) */
  var CUP_PRODUCT = 10254178943305;
  var CUP_VARIANT = 54720840008009;
  var FLAG = 'moushiCupRemoved';
  var busy = false;

  function removedByUser() {
    try { return sessionStorage.getItem(FLAG) === '1'; } catch (e) { return false; }
  }
  function markRemoved() {
    try { sessionStorage.setItem(FLAG, '1'); } catch (e) {}
  }

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }
  function hasDoypack(cart) {
    return cart.items.some(function (i) { return DOYPACKS.indexOf(i.product_id) !== -1; });
  }
  function hasCup(cart) {
    return cart.items.some(function (i) { return i.product_id === CUP_PRODUCT; });
  }

  /* Ajoute la Cup (qty 1) si un doypack est là et qu'elle manque. */
  function ensureGiftCup() {
    if (busy || removedByUser()) return;
    busy = true;
    getCart().then(function (cart) {
      if (hasDoypack(cart) && !hasCup(cart)) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: CUP_VARIANT, quantity: 1 }] })
        }).then(function () {
          /* re-rendre le drawer s'il est ouvert */
          var opener = document.querySelector('.open-cart');
          var drawer = document.getElementById('cartDrawer');
          if (drawer && drawer.classList.contains('open') && opener) opener.click();
        });
      }
    }).catch(function () {}).then(function () { busy = false; });
  }

  /* Note cadeau dans le drawer — ré-injectée à chaque re-render. */
  function injectNote() {
    var body = document.getElementById('cartBody');
    if (!body || body.querySelector('.cart-gift-note')) return;
    getCart().then(function (cart) {
      if (!hasDoypack(cart)) return;
      if (body.querySelector('.cart-gift-note')) return;
      var n = document.createElement('p');
      n.className = 'cart-gift-note';
      n.textContent = hasCup(cart)
        ? '1 Cup MŌUSHI offerte avec votre commande — la remise s’applique à l’étape de paiement.'
        : '1 Cup MŌUSHI offerte avec votre commande.';
      body.appendChild(n);
    }).catch(function () {});
  }

  /* Détection du retrait volontaire de la Cup (avant que main.js ne l'exécute). */
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-action="remove"]');
    if (rm) {
      var key = rm.dataset.key;
      getCart().then(function (cart) {
        var item = cart.items.filter(function (i) { return i.key === key; })[0];
        if (item && item.product_id === CUP_PRODUCT) markRemoved();
      }).catch(function () {});
      return;
    }
    /* Après un ajout au panier ou un changement de quantité, re-vérifier. */
    if (e.target.closest('.js-buy-cta, .btn-cart, [data-action="qty"], .open-cart')) {
      setTimeout(ensureGiftCup, 1400);
    }
  }, true);

  /* Drawer : observer les re-renders pour maintenir la note. */
  var bodyEl = document.getElementById('cartBody');
  if (bodyEl && window.MutationObserver) {
    new MutationObserver(function () { injectNote(); }).observe(bodyEl, { childList: true });
  }

  /* Au chargement : compléter un panier existant. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureGiftCup);
  } else {
    ensureGiftCup();
  }
}());
